module.exports = __webpack_public_path__ + "media/rendez-vous.b11ccc70.mp3";